import React from 'react'
import styled from '@emotion/styled'

interface PropsType {
  className?: string
  width?: string
  height?: string
}

export const PlusBirdIllustrationSvg = ({
  className,
  width,
  height = '140px'
}: PropsType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M55.9739 64.9151L50.4761 69.1021L46.9618 68.6171"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M50.2065 69.0092L47.3436 66.856"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M50.1983 69.2663L47.6051 70.4384"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3603 72.6771C23.5037 68.7452 28.0333 66.7584 32.3777 67.8444L37.0001 69L72.4676 76.0465C77.5472 77.0556 81.0158 81.776 80.4615 86.9251L79.14 99.2006C79.0472 100.063 78.8424 100.91 78.5309 101.72L77.0013 105.697C75.2641 110.214 70.5419 112.839 65.7889 111.929L25.7068 104.261C20.5286 103.271 17.009 98.4303 17.663 93.1989L18.6588 85.2346L20.3044 75.7093C20.4878 74.6475 20.8446 73.6231 21.3603 72.6771V72.6771Z"
      fill="url(#paint0_linear_1326_51867)"
    />
    <path
      d="M22.0924 74.9177C23.1126 69.6637 28.2839 66.3012 33.5 67.5V67.5L72.8741 74.4224C78.1292 75.3463 81.7332 80.2332 81.0634 85.5267L79.4218 98.4999L78.758 102.182C77.7728 107.646 72.5255 111.261 67.0691 110.235L27.3603 102.771C22.0893 101.78 18.5385 96.8071 19.3125 91.4998L20.6398 82.3979L22.0924 74.9177Z"
      fill="url(#paint1_linear_1326_51867)"
    />
    <rect
      x="24.3994"
      y="65.2098"
      width="60.1328"
      height="36.0797"
      rx="10"
      transform="rotate(10 24.3994 65.2098)"
      fill="url(#paint2_linear_1326_51867)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51.3201 81.7264C47.8227 89.3358 46.0402 93.221 45.9726 93.3822C45.9433 93.4521 45.9131 93.5188 45.8844 93.5825L45.8844 93.5825C45.8137 93.7392 45.7514 93.8772 45.7302 93.9972L45.7178 94.1023L45.7189 94.1501L45.8471 94.0937C45.8785 94.0783 45.9128 94.0607 45.9498 94.041L46.2033 93.8963L46.5137 93.697L46.9136 93.4265L47.816 94.4255L47.1794 94.8609L46.7498 95.17L46.3829 95.4196C46.2166 95.5284 46.0757 95.6133 45.9586 95.6749C45.6183 95.854 45.2893 95.9281 44.9723 95.8723C44.5531 95.7983 44.2287 95.53 44.0196 95.1204C43.8305 94.75 43.772 94.3487 43.8451 93.9343C43.8906 93.6766 44.0105 93.3231 44.206 92.8549L48.6249 82.3674L51.3201 81.7264ZM43.875 80.6036C44.634 80.7375 45.2205 81.1284 45.5925 81.7526C45.9489 82.3508 46.0475 83.0665 45.9034 83.8834C45.7334 84.8477 45.3278 85.7706 44.691 86.6489C44.0634 87.5145 43.2819 88.2751 42.3488 88.9295C41.4135 89.5855 40.4269 90.0613 39.3904 90.3547C38.3344 90.6536 37.3188 90.7198 36.3494 90.5489C36.1924 90.5212 36.024 90.4792 35.8434 90.4231L35.5633 90.3283L35.4712 90.2943L33.8714 93.9147L31.6662 93.5258L34.3894 87.3566L34.6937 86.643C34.9883 85.9255 35.2606 85.1796 35.5107 84.4053C35.8427 83.3776 36.0867 82.4204 36.2429 81.5341C36.2666 81.3996 36.2869 81.2755 36.3036 81.1618L36.326 80.999L36.3716 80.6431L38.9038 80.1131L38.6863 81.3359L38.5527 81.9417L38.4289 82.4425L38.2337 83.1809L38.3853 83.0393L38.8137 82.6665C39.6928 81.9325 40.5646 81.3787 41.4309 81.0071C42.3392 80.6174 43.1534 80.4764 43.875 80.6036ZM41.4363 82.5691C42.1528 82.1929 42.7182 82.0557 43.1213 82.1268C43.3251 82.1627 43.4457 82.2553 43.534 82.4486C43.6486 82.6997 43.6732 83.0624 43.5894 83.5379C43.48 84.158 43.1931 84.8856 42.7251 85.7156C42.2552 86.549 41.1829 87.7307 39.632 88.4088C38.5981 88.8609 37.4586 88.9121 36.2135 88.5626C36.763 87.4821 37.1895 86.7085 37.4932 86.242C37.9423 85.552 38.4601 84.9282 39.0469 84.3698C39.8719 83.5712 40.6683 82.9725 41.4363 82.5691ZM56.6392 93.8421L59.3445 87.9688L56.4504 88.6382L54.5095 93.9579C53.5079 95.0286 52.7001 95.4686 52.1211 95.3665C51.9251 95.332 51.7998 95.2581 51.7133 95.1386C51.6297 95.0231 51.6019 94.882 51.6373 94.6813C51.6794 94.4423 51.7665 94.1555 51.8996 93.8236L52.0145 93.5514L54.8342 87.1771L51.9768 87.8491L49.9949 93.0916C49.7859 93.6323 49.6443 94.1057 49.5727 94.512C49.4649 95.1237 49.5717 95.6768 49.901 96.1383C50.23 96.5994 50.7232 96.8863 51.347 96.9963L51.5838 97.0276C52.2886 97.0898 53.021 96.882 53.7822 96.4186L54.0931 96.2142L54.1097 96.3244C54.142 96.486 54.1909 96.6414 54.2568 96.79C54.4779 97.289 54.8463 97.6133 55.3377 97.7C55.7104 97.7657 56.0971 97.6583 56.4998 97.4117C56.5821 97.3613 56.6748 97.2997 56.7781 97.2266L57.1205 96.9731L57.5287 96.6502L57.998 96.2622L58.584 95.8018L57.7113 94.6996L57.277 95.0373L57.0891 95.18L56.9145 95.3064L56.6084 95.5111C56.5626 95.54 56.5194 95.5662 56.4791 95.5899L56.2726 95.7011C56.2444 95.7145 56.2193 95.7255 56.1975 95.7339L56.169 95.7418L56.1742 95.7595C56.1348 95.6414 56.1294 95.4687 56.1696 95.2408C56.2329 94.882 56.3889 94.4134 56.6392 93.8421ZM64.4553 89.7199C65.121 89.5635 65.7982 89.5457 66.4826 89.6663C67.1126 89.7774 67.6348 90.0045 68.0397 90.3531C68.4974 90.7473 68.7069 91.2324 68.6136 91.7612C68.4962 92.4275 68.0332 92.8513 67.3256 92.9678L66.7131 93.0687L66.7238 92.4548C66.7297 92.1177 66.6286 91.8535 66.4143 91.6323C66.1849 91.3957 65.8521 91.2348 65.3994 91.155C65.0076 91.0859 64.6619 91.126 64.3475 91.2726C64.0741 91.4001 63.953 91.5344 63.9262 91.6863C63.8907 91.8879 64.0537 92.1962 64.4998 92.604L65.6559 93.691C66.5184 94.548 66.9115 95.3848 66.7676 96.2005C66.6579 96.8227 66.3365 97.3667 65.8182 97.8201C65.3189 98.2569 64.6984 98.5614 63.9642 98.735C63.2398 98.9064 62.5028 98.9263 61.7579 98.7949C60.5411 98.5804 59.5815 97.9386 58.9089 96.8915L58.6396 96.4722L60.7892 95.0483L61.0934 95.8978C61.409 96.6861 61.9854 97.1404 62.8799 97.2981C63.3768 97.3857 63.8076 97.3326 64.189 97.1432C64.5365 96.9705 64.707 96.7692 64.7507 96.5213C64.7814 96.3474 64.7517 96.204 64.6577 96.0635C64.6269 96.0176 64.5829 95.9608 64.5258 95.8934L64.3156 95.6601L64.0287 95.3658C63.9745 95.3118 63.9172 95.2553 63.8568 95.1964L63.2211 94.5894L62.8097 94.1776C62.5008 93.8558 62.2762 93.5864 62.1333 93.3645C61.8647 92.9472 61.7685 92.4882 61.8525 92.012C61.9545 91.4335 62.2593 90.9346 62.7499 90.5297C63.2137 90.1469 63.7842 89.8777 64.4553 89.7199Z"
      fill="url(#paint3_linear_1326_51867)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51.3201 79.7264C47.8227 87.3358 46.0402 91.221 45.9726 91.3822C45.9433 91.4521 45.9131 91.5188 45.8844 91.5825L45.8844 91.5825C45.8137 91.7392 45.7514 91.8772 45.7302 91.9972L45.7178 92.1023L45.7189 92.1501L45.8471 92.0937C45.8785 92.0783 45.9128 92.0607 45.9498 92.041L46.2033 91.8963L46.5137 91.697L46.9136 91.4265L47.816 92.4255L47.1794 92.8609L46.7498 93.17L46.3829 93.4196C46.2166 93.5284 46.0757 93.6133 45.9586 93.6749C45.6183 93.854 45.2893 93.9281 44.9723 93.8723C44.5531 93.7983 44.2287 93.53 44.0196 93.1204C43.8305 92.75 43.772 92.3487 43.8451 91.9343C43.8906 91.6766 44.0105 91.3231 44.206 90.8549L48.6249 80.3674L51.3201 79.7264ZM43.875 78.6036C44.634 78.7375 45.2205 79.1284 45.5925 79.7526C45.9489 80.3508 46.0475 81.0665 45.9034 81.8834C45.7334 82.8477 45.3278 83.7706 44.691 84.6489C44.0634 85.5145 43.2819 86.2751 42.3488 86.9295C41.4135 87.5855 40.4269 88.0613 39.3904 88.3547C38.3344 88.6536 37.3188 88.7198 36.3494 88.5489C36.1924 88.5212 36.024 88.4792 35.8434 88.4231L35.5633 88.3283L35.4712 88.2943L33.8714 91.9147L31.6662 91.5258L34.3894 85.3566L34.6937 84.643C34.9883 83.9255 35.2606 83.1796 35.5107 82.4053C35.8427 81.3776 36.0867 80.4204 36.2429 79.5341C36.2666 79.3996 36.2869 79.2755 36.3036 79.1618L36.326 78.999L36.3716 78.6431L38.9038 78.1131L38.6863 79.3359L38.5527 79.9417L38.4289 80.4425L38.2337 81.1809L38.3853 81.0393L38.8137 80.6665C39.6928 79.9325 40.5646 79.3787 41.4309 79.0071C42.3392 78.6174 43.1534 78.4764 43.875 78.6036ZM41.4363 80.5691C42.1528 80.1929 42.7182 80.0557 43.1213 80.1268C43.3251 80.1627 43.4457 80.2553 43.534 80.4486C43.6486 80.6997 43.6732 81.0624 43.5894 81.5379C43.48 82.158 43.1931 82.8856 42.7251 83.7156C42.2552 84.549 41.1829 85.7307 39.632 86.4088C38.5981 86.8609 37.4586 86.9121 36.2135 86.5626C36.763 85.4821 37.1895 84.7085 37.4932 84.242C37.9423 83.552 38.4601 82.9282 39.0469 82.3698C39.8719 81.5712 40.6683 80.9725 41.4363 80.5691ZM56.6392 91.8421L59.3445 85.9688L56.4504 86.6382L54.5095 91.9579C53.5079 93.0286 52.7001 93.4686 52.1211 93.3665C51.9251 93.332 51.7998 93.2581 51.7133 93.1386C51.6297 93.0231 51.6019 92.882 51.6373 92.6813C51.6794 92.4423 51.7665 92.1555 51.8996 91.8236L52.0145 91.5514L54.8342 85.1771L51.9768 85.8491L49.9949 91.0916C49.7859 91.6323 49.6443 92.1057 49.5727 92.512C49.4649 93.1237 49.5717 93.6768 49.901 94.1383C50.23 94.5994 50.7232 94.8863 51.347 94.9963L51.5838 95.0276C52.2886 95.0898 53.021 94.882 53.7822 94.4186L54.0931 94.2142L54.1097 94.3244C54.142 94.486 54.1909 94.6414 54.2568 94.79C54.4779 95.289 54.8463 95.6133 55.3377 95.7C55.7104 95.7657 56.0971 95.6583 56.4998 95.4117C56.5821 95.3613 56.6748 95.2997 56.7781 95.2266L57.1205 94.9731L57.5287 94.6502L57.998 94.2622L58.584 93.8018L57.7113 92.6996L57.277 93.0373L57.0891 93.18L56.9145 93.3064L56.6084 93.5111C56.5626 93.54 56.5194 93.5662 56.4791 93.5899L56.2726 93.7011C56.2444 93.7145 56.2193 93.7255 56.1975 93.7339L56.169 93.7418L56.1742 93.7595C56.1348 93.6414 56.1294 93.4687 56.1696 93.2408C56.2329 92.882 56.3889 92.4134 56.6392 91.8421ZM64.4553 87.7199C65.121 87.5635 65.7982 87.5457 66.4826 87.6663C67.1126 87.7774 67.6348 88.0045 68.0397 88.3531C68.4974 88.7473 68.7069 89.2324 68.6136 89.7612C68.4962 90.4275 68.0332 90.8513 67.3256 90.9678L66.7131 91.0687L66.7238 90.4548C66.7297 90.1177 66.6286 89.8535 66.4143 89.6323C66.1849 89.3957 65.8521 89.2348 65.3994 89.155C65.0076 89.0859 64.6619 89.126 64.3475 89.2726C64.0741 89.4001 63.953 89.5344 63.9262 89.6863C63.8907 89.8879 64.0537 90.1962 64.4998 90.604L65.6559 91.691C66.5184 92.548 66.9115 93.3848 66.7676 94.2005C66.6579 94.8227 66.3365 95.3667 65.8182 95.8201C65.3189 96.2569 64.6984 96.5614 63.9642 96.735C63.2398 96.9064 62.5028 96.9263 61.7579 96.7949C60.5411 96.5804 59.5815 95.9386 58.9089 94.8915L58.6396 94.4722L60.7892 93.0483L61.0934 93.8978C61.409 94.6861 61.9854 95.1404 62.8799 95.2981C63.3768 95.3857 63.8076 95.3326 64.189 95.1432C64.5365 94.9705 64.707 94.7692 64.7507 94.5213C64.7814 94.3474 64.7517 94.204 64.6577 94.0635C64.6269 94.0176 64.5829 93.9608 64.5258 93.8934L64.3156 93.6601L64.0287 93.3658C63.9745 93.3118 63.9172 93.2553 63.8568 93.1964L63.2211 92.5894L62.8097 92.1776C62.5008 91.8558 62.2762 91.5864 62.1333 91.3645C61.8647 90.9472 61.7685 90.4882 61.8525 90.012C61.9545 89.4335 62.2593 88.9346 62.7499 88.5297C63.2137 88.1469 63.7842 87.8777 64.4553 87.7199Z"
      fill="white"
    />
    <path
      d="M61.5158 68.8114L56.0181 72.9983L52.5038 72.5134"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.7495 72.9053L52.8866 70.7521"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.7403 73.1625L53.1471 74.3345"
      stroke="#5E7FA6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M67.7586 14.8696C60.258 24.9799 54.8658 32.2878 51.5821 36.7934C48.0433 41.649 44.5242 46.583 41.0247 51.5953L41.0244 51.5952C40.9565 51.6925 40.8994 51.797 40.8542 51.9067C37.6627 59.6506 43.0574 59.9507 57.0383 52.8071C70.3197 46.0209 74.8551 33.5734 70.6443 15.4643L70.6458 15.464C70.4403 14.5904 69.5655 14.0487 68.6919 14.2542C68.3177 14.3423 67.9867 14.5602 67.758 14.8691L67.7586 14.8696Z"
      fill="url(#paint4_linear_1326_51867)"
    />
    <path
      d="M24.1047 39.618L22.0038 46.0741C21.8649 46.5008 22.0982 46.9593 22.525 47.0981C22.72 47.1616 22.9318 47.149 23.1179 47.0628L29.7228 44.0031V44.0031C28.9349 43.6914 28.0441 43.2126 27.0505 42.5668C26.0569 41.921 25.0749 40.9381 24.1047 39.618Z"
      fill="#7B9CC2"
    />
    <path
      d="M95.3731 48.1555C91.4511 55.3504 84.341 67.1827 68.3662 69.0809C49.3617 71.3392 40.2164 57.7564 33.4366 49.2919C30.3776 45.4728 31.7957 46.138 26.6005 43.445C23.5748 41.8765 18.6697 34.1528 26.0736 28.2076C30.1364 24.9452 35.06 25.2459 38.3616 28.0199C41.0765 30.301 40.957 33.8083 46.4475 36.2237C56.1842 40.5069 99.7143 38.6237 99.1725 40.5757C98.2164 44.0199 97.8219 43.6633 95.3731 48.1555Z"
      fill="url(#paint5_linear_1326_51867)"
    />
    <path
      d="M92.6822 51.6557C93.5392 49.8069 100.48 47.5748 103.169 45.2899C105.142 43.613 119.517 40.2271 119.802 36.8286C120.086 33.4301 105.15 39.637 93.6857 39.674"
      fill="url(#paint6_linear_1326_51867)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.2286 69.3306C49.2127 69.3191 40.9933 58.8796 34.884 51.1201C34.3885 50.4908 33.9069 49.879 33.4366 49.2919C32.7512 48.4362 32.2906 47.8056 31.93 47.3119C30.9309 45.9443 30.6994 45.6274 28.583 44.4855C32.4592 41.7353 41.8369 43.3848 51.1349 48.753C61.6925 54.8484 68.1493 63.43 65.5567 67.9205C65.2338 68.4797 64.7859 68.9491 64.2286 69.3306Z"
      fill="#BEF0F0"
    />
    <ellipse
      rx="1.70108"
      ry="1.7039"
      transform="matrix(-0.906308 0.422618 0.422618 0.906308 27.1435 35.9553)"
      fill="#7B9CC2"
    />
    <path
      d="M85.5176 18.1759C89.3137 16.2271 85.7225 43.7304 81.6513 50.4904C78.9372 54.997 72.4854 57.3832 62.296 57.6488C61.2083 56.3074 59.6476 54.8265 57.6139 53.2062C55.5803 51.5858 53.4157 50.0986 51.1204 48.7444C53.6654 44.6227 58.265 39.6051 64.919 33.6918C74.9 24.8217 81.7215 20.1247 85.5176 18.1759Z"
      fill="url(#paint7_linear_1326_51867)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1326_51867"
        x1="53.7663"
        y1="109.826"
        x2="25.3604"
        y2="68.7466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8E87F5" />
        <stop offset="1" stop-color="#C4C0FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1326_51867"
        x1="23"
        y1="72"
        x2="73"
        y2="109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CCC8FF" />
        <stop offset="1" stop-color="#A6A0F3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1326_51867"
        x1="80.6403"
        y1="99.556"
        x2="25.6328"
        y2="68.3335"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7267F0" />
        <stop offset="1" stop-color="#8E86F6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1326_51867"
        x1="36"
        y1="81"
        x2="63.5"
        y2="99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8077EF" />
        <stop offset="1" stop-color="#6458F3" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1326_51867"
        x1="70.2051"
        y1="3.25576"
        x2="77.9963"
        y2="12.1566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B8F4F4" />
        <stop offset="1" stop-color="#70E2E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1326_51867"
        x1="52.4885"
        y1="77.0344"
        x2="40.1124"
        y2="31.2932"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#95ECEC" />
        <stop offset="1" stop-color="#60D8D8" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1326_51867"
        x1="123.206"
        y1="47.7334"
        x2="105.982"
        y2="60.8104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#95ECEC" />
        <stop offset="1" stop-color="#60D8D8" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1326_51867"
        x1="85.2223"
        y1="-20.731"
        x2="55.3579"
        y2="51.9511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B8F4F4" />
        <stop offset="1" stop-color="#73E2E2" />
      </linearGradient>
    </defs>
  </svg>
)

export const PlusBirdIllustration = styled(PlusBirdIllustrationSvg)`
  display: block;
  margin: auto;
`
